import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const initialBhakts = [
  { name: "Abhishek Kumar", place: "Mumbai", score: 94 },
  { name: "Ratnesh Sinha", place: "Ranchi", score: 92 },
  { name: "Sunil Prasad", place: "Rourkela", score: 90 },
  { name: "Ankur Garg", place: "Delhi", score: 89 },
  { name: "Anuradha Kumari", place: "Patna", score: 87 },
  { name: "Rakesh Singh", place: "Mumbai", score: 86 },
  { name: "Trupti Lovekar", place: "Navi Mumbai", score: 85 },
  { name: "Satish Tambad", place: "Pune", score: 84 },
  { name: "Nirbhay Kumar", place: "Bengaluru", score: 83 },
  { name: "Vijay Vichare", place: "Nagpur", score: 82 },
];

const BhaktiScorecard = () => {
  const { isLoggedIn, user } = useSelector((state) => state.authReducer);
  const [userName] = useState(user?.name || "Guest");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Hotels");
  const [rankings, setRankings] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const shuffleAndSelectTop = (data) => {
    const shuffled = [...data]
      .sort(() => 0.5 - Math.random())
      .slice(0, 10)
      .sort((a, b) => b.score - a.score)
      .map((item, index) => ({ rank: index + 1, ...item }));
    setRankings(shuffled);
  };

  useEffect(() => {
    let dataSource;
    if (activeTab === "Hotels") dataSource = initialBhakts;
    else if (activeTab === "Restaurants") dataSource = initialRestaurants;
    else dataSource = initialCafeterias;

    shuffleAndSelectTop(dataSource);
    const interval = setInterval(() => shuffleAndSelectTop(dataSource), 5000);
    return () => clearInterval(interval);
  }, [activeTab]);

  const today = new Date().toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="flex flex-col min-h-screen font-sans text-white bg-black ">
      <header className="flex justify-between items-center px-4 py-1 bg-black shadow-md sticky top-0 z-50 border-b border-green-500">
        <div
          onClick={() => navigate("/rankings")}
          className="text-lg lg:text-xl font-bold text-yellow-200 tracking-wide cursor-pointer"
        >
          🌼 Bhakti Rankings
        </div>

        <div className="hidden md:flex items-center space-x-2">
          {isLoggedIn && (
            <>
              <span className="text-white font-medium">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-8 h-8 mt-2 flex items-center justify-center text-lg bg-green-500 text-white rounded-full hover:bg-green-600 transition sm:w-9 sm:h-9"
                title="Logout"
              >
                ⏻
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden mt-2 w-8 h-8 flex items-center justify-center text-xl bg-green-700 text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>        
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-green-700 flex flex-col px-4 py-3 space-y-3">
          {isLoggedIn && (
            <div className="border-t pt-3 border-green-500 text-white">
              <p className="mb-2 text-sm">{userName}</p>
              <button
                onClick={handleLogout}
                className="bg-green-500 text-white mt-4 px-4 py-2 rounded text-sm hover:bg-green-600 w-full transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      <main className="flex-1 bg-black text-white p-4 overflow-y-auto">
        <div className="text-center mb-2">
          <p className="text-white font-medium">{today}</p>
        </div>

        <div className="overflow-x-auto bg-black rounded-lg shadow-md">
          <table className="min-w-full text-sm lg:text-m">
            <thead className="bg-cyan-600 text-white uppercase text-xs lg:text-sm">
              <tr>
                <th className="py-2 px-3 border">Rank</th>
                <th className="py-2 px-4 border">Bhakt Name</th>
                <th className="py-2 px-4 border">Place</th>
                <th className="py-2 px-3 border">Score</th>
              </tr>
            </thead>
            <tbody>
              {rankings.map(({ rank, name, place, score }) => (
                <tr
                  key={name}
                  className="text-left hover:bg-gray-500 text-black transition-all"
                >
                  <td className="py-2 px-2 border text-center">{rank}</td>
                  <td className="py-2 px-2 border">{name}</td>
                  <td className="py-2 px-2 border">{place}</td>
                  <td className="py-2 px-2 border text-center font-semibold">
                    {score}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      <footer className="bg-black border-t border-green-400 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-green-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-green-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-green-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-green-200 transition">Contact</Link>
          </div>
        </div>
      </footer> 
    </div>
  );
};

export default BhaktiScorecard;
